<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('xtgl')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('cpgl')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchright">
                        <el-button size="small" type="primary" @click="openadd">+{{$t('addcp')}}</el-button>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column width="180" prop="productName" :label="$t('cpmc')"></el-table-column>
                        <el-table-column prop="loanTime" :label="$t('dkqx')"></el-table-column>
                        <el-table-column prop="interestRate" :label="$t('lx')"></el-table-column>
                        <el-table-column prop="serviceFee" :label="$t('fwf')"></el-table-column>
                        <el-table-column prop="rolloverRates" :label="$t('zqfl')"></el-table-column>
                        <el-table-column prop="penaltyRate" :label="$t('fxfl')"></el-table-column>
                        <el-table-column width="250" prop="feeMethod" :label="$t('flsqfs')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.feeMethod==1" type="info" size="mini">{{$t('fk1')}}</el-tag>
                                <el-tag v-if="scope.row.feeMethod==2" type="info" size="mini">{{$t('fk2')}}</el-tag>
                                <el-tag v-if="scope.row.feeMethod==3" type="info" size="mini">{{$t('fk3')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="conditionsUse" :label="$t('sytj')"></el-table-column>
                        <el-table-column prop="interestStart" :label="$t('jxks')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.interestStart==1" type="primary" size="mini">{{$t('fkdr')}}</el-tag>
                                <el-tag v-if="scope.row.interestStart==2" type="info" size="mini">{{$t('fkcr')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="prepaymentMethod" :label="$t('tqhk')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.prepaymentMethod==1" type="primary" size="mini">{{$t('qxjx')}}</el-tag>
                                <el-tag v-if="scope.row.prepaymentMethod==2" type="info" size="mini">{{$t('sjsyjz')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="state" :label="$t('status')">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.state==1" type="primary" size="mini">{{$t('qiyong')}}</el-tag>
                                <el-tag v-if="scope.row.state==0" type="warning" size="mini">{{$t('jinyong')}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-button size="small" @click="openedit(scope.row)" type="primary" icon="el-icon-edit"
                                    circle plain style="margin-right:5px;"></el-button>
                                <el-popconfirm title="$t(isDel')" @confirm="deleteproduct(scope.row)">
                                    <el-button size="small" type="warning" icon="el-icon-delete-solid" circle slot="reference" plain></el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <pop-up :title="status == 1? $t('addcp') : $t('editcp')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box">
                <el-form ref="form" :inline="true" :model="form" :rules="rules" size="small" label-width="330px">
                    <el-form-item :label="$t('cpmc')">
                        <el-input v-model="form.productName" />
                    </el-form-item>
                    <el-form-item :label="$t('dkqx')">
                        <el-input v-model="form.loanTime" />
                    </el-form-item>
                    <el-form-item :label="$t('lx')">
                        <el-input v-model="form.interestRate" />
                    </el-form-item>
                    <el-form-item :label="$t('fwf')">
                        <el-input v-model="form.serviceFee" />
                    </el-form-item>
                    <el-form-item :label="$t('zqfl')">
                        <el-input v-model="form.rolloverRates" />
                    </el-form-item>
                    <el-form-item :label="$t('fxfl')">
                        <el-input v-model="form.penaltyRate" />
                    </el-form-item>
                    <el-form-item :label="$t('sytj')">
                        <el-input v-model="form.conditionsUse" />
                    </el-form-item>
                    <el-form-item :label="$t('flsqfs')">
                        <el-select size="small" v-model="form.feeMethod" style="width:240px;" :placeholder="$t('qq1')"  >
                            <el-option :label="$t('fk1')" :value="1"></el-option>
                            <el-option :label="$t('fk2')" :value="2"></el-option>
                            <el-option :label="$t('fk3')" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item :label="$t('jxks')">
                        <el-select size="small" v-model="form.interestStart" style="width:150px;" :placeholder="$t('qq2')"  >
                            <el-option :label="$t('fkdr')" :value="1"></el-option>
                            <el-option :label="$t('fkcr')" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('tqhk')">
                        <el-select size="small" v-model="form.prepaymentMethod" style="width:250px;" :placeholder="$t('qq3')"  >
                            <el-option :label="$t('qxjx')" :value="1"></el-option>
                            <el-option :label="$t('sjsyjz')" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('status')">
                        <el-radio-group v-model="form.state">
                            <el-radio :label="1">{{$t('qiyong')}}</el-radio>
                            <el-radio :label="0">{{$t('jinyong')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('pingt')">
                        <el-input v-model="form.platform" />
                    </el-form-item>
                    <el-form-item label="国家" >
                        <el-select v-model="form.nation" placeholder="请选择国家">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/sys"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                options: [{
                        value: 'mx',
                        label: '墨西哥'
                        }, {
                        value: 'pe',
                        label: '秘鲁'
                    }],
                form: {
                    id: null,
                    productName: null,
                    loanTime: null,
                    interestRate: null,
                    serviceFee: null,
                    rolloverRates: null,
                    penaltyRate: null,
                    feeMethod: null,
                    conditionsUse: null,
                    interestStart: null,
                    prepaymentMethod: null,
                    createTime: null,
                    state: null,
                    platform:null,
                    nation:null,
                },
                defaultProps: {
                    label: "name",
                    isLeaf: 'isLeaf'
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            openadd() {
                this.showadd = true
                this.status = 1
                this.form = {
                    id: null,
                    productName: null,
                    loanTime: null,
                    interestRate: null,
                    serviceFee: null,
                    rolloverRates: null,
                    penaltyRate: null,
                    feeMethod: null,
                    conditionsUse: null,
                    interestStart: null,
                    prepaymentMethod: null,
                    createTime: null,
                    state: null,
                    nation:null,
                    platform:null
                }
            },
            openedit(row) {
                this.status = 2
                this.form.id = row.id
                this.form.productName = row.productName
                this.form.loanTime = row.loanTime
                this.form.interestRate = row.interestRate
                this.form.serviceFee = row.serviceFee
                this.form.rolloverRates = row.rolloverRates
                this.form.penaltyRate = row.penaltyRate
                this.form.feeMethod = row.feeMethod
                this.form.conditionsUse = row.conditionsUse
                this.form.interestStart = row.interestStart
                this.form.prepaymentMethod = row.prepaymentMethod
                this.form.createTime = row.createTime
                this.form.state = row.state
                this.form.platform = row.platform
                this.form.nation = row.nation
                this.showadd = true
            },
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },
            handleNodeClick(mydata, node, obj) {
                this.loading = true
                this.getList()
            },
            deleteproduct(row) {
                _api.delete(apiurl.product, row.id).then(res => {
                    this.$notify({
                        title: this.$t('success'),
                        message: this.$t('delSuccess'),
                        type: 'success'
                    });
                    this.getList()

                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    });
                })
            },
            getconfirm() {
                if (this.status == 1) { //如果是添加
                    _api.post(apiurl.product, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('addSuccess'),
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            productName: null,
                            loanTime: null,
                            interestRate: null,
                            serviceFee: null,
                            rolloverRates: null,
                            penaltyRate: null,
                            feeMethod: null,
                            conditionsUse: null,
                            interestStart: null,
                            prepaymentMethod: null,
                            state: null,
                            nation:null,
                            platform: null
                        }

                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                } else { //如果是编辑
                    _api.put(apiurl.product, this.form).then(res => {
                        this.$notify.success({
                            title: this.$t('success'),
                            message: this.$t('editSuccess'),
                        })
                        this.getList()
                        this.showadd = false
                        this.form = {
                            id: null,
                            productName: null,
                            loanTime: null,
                            interestRate: null,
                            serviceFee: null,
                            rolloverRates: null,
                            penaltyRate: null,
                            feeMethod: null,
                            conditionsUse: null,
                            interestStart: null,
                            prepaymentMethod: null,
                            state: null,
                            nation:null,
                            platform: null
                        }
                    }).catch(err => {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: err.data.message
                        })
                    })
                }
                  
            },
            getList() {
                this.loading = true
                _api.get(apiurl.product, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
            
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>